<template>
    <div class="m-blockdetail">
        <h1 class="flex-left title">
            <i class="iconfont iconqukuaixiangqinglogo"></i>
            <span>区块高度&nbsp;&nbsp;{{ block.infos.height }}</span>
        </h1>
        <p class="hash flex-left table-shadow">
            区块哈希
            <span>{{ filterHash(block.infos.hash, 20) }}</span>
            <i
                class="iconfont iconfuzhi"
                v-clipboard:copy="block.infos.hash"
                v-clipboard:success="success"
                v-clipboard:error="error"
            ></i>
        </p>
        <BlockInfo :infos="block.infos"></BlockInfo>
        <!-- 数据记录 -->
        <div class="tx-record table-shadow">
            <h2>上链记录</h2>
            <!-- 表格部分 -->
            <el-table
                :data="block.txs"
                stripe
                style="width: 100%"
                class="data-table"
                :cell-class-name="groupCellName"
                empty-text="暂无数据"
                v-loading="loading"
                element-loading-text="拼命加载中..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
            >
                <el-table-column label width="25">
                    <template v-slot="item">
                        <div>
                            <div
                                :class="{
                                    'start-line': item.row.tradeG === 3,
                                    'middle-line': item.row.tradeG === 1,
                                    'end-line': item.row.tradeG === 2,
                                }"
                            >
                                <span v-if="item.row.tradeG === 3"></span>
                                <i></i>
                                <span v-if="item.row.tradeG !== 3"></span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="上链哈希" width="160">
                    <template v-slot="item">
                        <div>
                            <p class="group-title" v-if="item.row.tradeG === 3">
                                数据组
                            </p>
                            <router-link
                                :to="`/tradeHash?hash=${item.row.txHash}`"
                                class="light flex-left"
                            >
                                <i
                                    class="iconfont err-ico"
                                    :class="{
                                        'iconjinggao-chucuo': tradeAccuracy(
                                            item.row.tx.execer,
                                            item.row.receipt.ty,
                                            item.row.receipt.tyName
                                        ),
                                    }"
                                ></i>
                                {{ filterHash(item.row.txHash, 10) }}
                            </router-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="hash" label="发送方" width="160">
                    <template v-slot="item">
                        <router-link
                            :to="`/address?address=${item.row.fromAddr}`"
                            class="light"
                            >{{
                                filterHash(item.row.fromAddr, 10)
                            }}</router-link
                        >
                    </template>
                </el-table-column>
                <el-table-column width="50">
                    <template v-slot>
                        <i class="iconfont iconjiantou-you"></i>
                    </template>
                </el-table-column>
                <el-table-column prop="hash" label="接收方" width="160">
                    <template v-slot="item">
                        <router-link
                            :to="`/address?address=${item.row.tx.to}`"
                            class="light"
                            >{{ filterHash(item.row.tx.to, 10) }}</router-link
                        >
                    </template>
                </el-table-column>
                <el-table-column label="上链时间" width="160">
                    <template v-slot="item">{{
                        formatTime(item.row.blockTime)
                    }}</template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 底部分页 -->
        <div class="bottom-page flex-right">
            <PageContainer
                @pageChange="pageChange"
                @sizeChange="sizeChange"
                :currentPage="pages.currentPage"
                :pageSize="pages.pageSize"
                :total="pages.total"
            ></PageContainer>
        </div>
    </div>
</template>

<script setup>
import { tradeAccuracy, formatTime, filterHash } from "@/utils/filters";
import PageContainer from "@/components/mobile/PageContainer.vue";
import BlockInfo from "./BlockInfos";
import { groupCellName } from "@/mixins/common";
import BlockMixins from "@/mixins/blockDetail";
import { useRoute } from "vue-router";
import { success, error } from "@/mixins/common";
import { watch } from "vue";

const { getBlock, block, loading, pages, pageChange, sizeChange } =
    BlockMixins();
console.log(block);
const route = useRoute();
watch(
    () => route.query.height,
    (height) => {
        pages.currentPage = 1;
        getBlock(height);
    },
    {
        immediate: true,
    }
);
</script>

<style lang="scss">
.m-blockdetail {
    padding: 10px 20px 17px;
    .title {
        .iconqukuaixiangqinglogo {
            color: $blue;
            font-size: 18px;
        }
        span {
            margin-left: 10px;
            color: $black;
            font-size: 14px;
            font-family: PingFangSC-Semibold;
            font-weight: 500;
        }
    }
    .hash {
        height: 37px;
        padding: 10px;
        margin-top: 15px;
        background: $white;
        color: $black;
        span {
            margin-left: 10px;
            // width: 200px;
            display: inline-block;
        }
        i {
            margin-left: 20px;
            color: $blue;
        }
    }
    .tx-record {
        .err-ico {
            color: #e45359;
            font-size: 12px;
            width: 13px;
            margin-right: 5px;
            display: inline-flex;
        }
        .data-table {
            font-size: 12px;
        }
        h2 {
            margin: 20px 0 10px;
            color: $black;
            font-size: 14px;
            font-family: PingFangSC-Semibold;
            font-weight: 500;
        }
        .el-table__header thead tr {
            height: 60px;
            color: $black;
        }
        .iconjiantou-you {
            font-size: 20px;
            color: #9aaab9;
        }
        .token-icon {
            height: 23px;
        }
        .tx-start,
        .tx-middle,
        .tx-end {
            background: $group_bg !important;
            .light,
            .iconjiantou-you {
                color: $group_title;
            }
        }
        .tx-start {
            padding-top: 45px;
        }
        .tx-start:nth-of-type(2) {
            padding-top: 0;
            // .cell {
            //   padding: 0;
            // }
        }
        .tx-start:nth-of-type(1),
        .tx-middle:nth-of-type(1),
        .tx-end:nth-of-type(1) {
            padding: 0;
            text-align: center;
            span {
                background: $group_title;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                display: block;
            }
            i {
                margin: 0 auto;
                display: block;
                width: 1px;
                background: $group_title;
            }
            .start-line {
                position: absolute;
                bottom: 0;
                width: 5px;
                span {
                    margin: 0 auto;
                }
                i {
                    height: 19.5px;
                }
            }
            .middle-line {
                width: 5px;
                span {
                    position: absolute;
                    top: 45%;
                }
                i {
                    height: 50px;
                }
            }
            .end-line {
                position: absolute;
                top: 0;
                width: 5px;
                span {
                    margin: 0 auto;
                }
                i {
                    height: 20.5px;
                }
            }
        }
        .group-title {
            margin: 15px 0 9px 20px;
            font-size: 14px;
            font-family: PingFangSC-Semibold;
            font-weight: 500;
            color: $group_title;
        }
    }
    .el-table td:nth-of-type(2) .cell {
        padding-left: 0;
    }
    .el-table th:nth-of-type(2) .cell {
        padding-left: 20px;
    }
    .loading-line {
        height: 60px;
        line-height: 18px;
    }
    .bottom-page {
        margin-top: 20px;
    }
    .el-loading-mask {
        top: 60px;
    }
}
</style>
